import {emailReg, TEL_VALUE_MIN_LENGH} from "@main/constants";

//валидация email
export function isValidEmail(e) {
    const target = e?.target ? e.target : e;
    const value = target.value;
    const parent = target.closest(".js-input");

    let isValid = true;

    if (value.length > 0 && !emailReg.test(value)) {
        parent.classList.add("input--error");
        isValid = false;
    } else {
        parent.classList.remove("input--error");
    }

    return isValid;
}

//получить только числовые значения
export const getInputNumberValue = input => {
    return input.value.replace(/\D/g, "");
};

//поле номера телефона
export function getPhoneMasked(fields) {
    const onPhoneInput = e => {
        const input = e.target;
        let inputNumbersValue = getInputNumberValue(input);
        let formattedInputValue = "";
        let selectionStart = input.selectionStart;

        if (!inputNumbersValue) {
            input.value = "";
            return;
        }

        if (input.value.length !== selectionStart) {
            const {data} = e;

            if (data && /\D/g.test(data)) {
                input.value = inputNumbersValue;
            }

            return;
        }

        if (["7", "8", "9"].indexOf(inputNumbersValue[0]) > -1) {
            if (inputNumbersValue[0] === "9") {
                inputNumbersValue = `7${inputNumbersValue}`;
            }

            const firstSymbols = inputNumbersValue[0] === "8" ? "8" : "+7";
            formattedInputValue = firstSymbols + " ";

            if (inputNumbersValue.length > 1) {
                formattedInputValue += "(" + inputNumbersValue.substring(1, 4);
            }

            if (inputNumbersValue.length >= 5) {
                formattedInputValue += ") " + inputNumbersValue.substring(4, 7);
            }

            if (inputNumbersValue.length >= 8) {
                formattedInputValue += "-" + inputNumbersValue.substring(7, 9);
            }

            if (inputNumbersValue.length >= 10) {
                formattedInputValue += "-" + inputNumbersValue.substring(9, 11);
            }
        } else {
            formattedInputValue = `+${inputNumbersValue.substring(0, 16)}`;
        }

        input.value = formattedInputValue;
    };

    const onPhoneKeydown = e => {
        const {target} = e;

        if (e.keyCode === 8 && getInputNumberValue(target).length === 1) {
            target.value = "";
        }
    };

    const onPhonePaste = e => {
        const pasted = e.clipboardData || window.clipboardData;
        const input = e.target;
        const inputNumbersValue = getInputNumberValue(input);

        if (pasted) {
            const pastedText = pasted.getData("Text");

            if (/\D/g.test(pastedText)) {
                input.value = inputNumbersValue;
            }
        }
    };

    const onPhoneFocusOut = e => {
        const input = e.target;
        const inputNumbersValue = getInputNumberValue(input);
        const parent = input.parentElement;

        if (inputNumbersValue.length > 0 && inputNumbersValue.length < TEL_VALUE_MIN_LENGH) {
            parent.classList.add("input--error");
        } else {
            parent.classList.remove("input--error");
        }
    };

    fields.forEach(field => field.addEventListener("input", onPhoneInput));
    fields.forEach(field => field.addEventListener("keydown", onPhoneKeydown));
    fields.forEach(field => field.addEventListener("paste", onPhonePaste));
    fields.forEach(field => field.addEventListener("focusout", onPhoneFocusOut));
}

//валидация формы по атрибутам
export function checkValidity(form) {
    let isValid = true;
    const inputNodes = form.querySelectorAll("[required]");

    inputNodes?.forEach(input => {
        const errorWrap = input.closest(".js-input");

        if (input.value.trim().length && input.type === "email" && !isValidEmail(input)) {
            isValid = false;
            return false;
        }

        if (!input.value.trim().length || !input.checkValidity()) {
            if (errorWrap) {
                errorWrap.classList.add("input--error");
            }

            isValid = false;
            return false;
        }

        if (errorWrap) {
            errorWrap.classList.remove("input--error");
        }
    });

    document.querySelector(".input--error")?.scrollIntoView({block: "center", behavior: "smooth"});
    return isValid;
}

export function removeCurrent(items) {
    items.forEach((item) => {
        item.classList.remove("current");
    });
}
